import {connect} from 'react-redux';
import Step2 from './Step4';
import {submitStep} from "../../actions/submitStep";
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           locales: {current: language},
                           stepPayload: {payload},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  language,
  payload,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {submitStep, prevCompletedStepSignFalse}
)(Step2);
